import { useTranslate } from "@opensea/next-translate"
import React from "react"
import { ChainMedia } from "@/components/common/media/ChainMedia.react"
import { useConnectedChain } from "@/providers/Wallet/selectors"
import { TxItem } from "../components/TxItem.react"
import { useTransactionUrl } from "../hooks/useTransactionUrl"
import type { TxState } from "../types"

type OpenSeaProTradeProps = {
  state: TxState
  transactionHash: string | undefined
  nonce?: number
}

export function OpenSeaProTrade({
  state,
  transactionHash,
  nonce,
}: OpenSeaProTradeProps) {
  const t = useTranslate("transactions")
  const transactionUrl = useTransactionUrl(transactionHash)

  const connectedChain = useConnectedChain()
  const isPending = state === "PENDING"

  return (
    <TxItem href={isPending ? undefined : transactionUrl} target="_blank">
      <TxItem.Avatar state={state}>
        <ChainMedia chain={connectedChain ?? "ETHEREUM"} />
      </TxItem.Avatar>
      <TxItem.Content>
        <TxItem.Title>
          {t("txItem.openSeaProTrade.title", "OpenSea Pro Trade")}
        </TxItem.Title>
      </TxItem.Content>
      {isPending ? (
        <TxItem.Pending href={transactionUrl} nonce={nonce} />
      ) : null}
    </TxItem>
  )
}
